var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessages3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.01 18.74-.96-.63a.755.755 0 0 1-.31-.83c.07-.23.1-.5.1-.8v-4.07c0-1.63-1.02-2.65-2.65-2.65H5.4c-.12 0-.23.01-.34.02a.799.799 0 0 1-.57-.2.72.72 0 0 1-.24-.55V6.26c0-2.94 2.06-5 5-5h8.5c2.94 0 5 2.06 5 5v5.1c0 1.45-.49 2.73-1.39 3.61-.72.73-1.72 1.2-2.86 1.34v1.11c0 .6-.33 1.14-.85 1.42-.24.11-.5.17-.75.17-.31 0-.62-.09-.89-.27zm.94-1.24c.06-.03.06-.08.06-.09V15.6c0-.41.34-.75.75-.75 1.05 0 1.94-.33 2.55-.95.63-.62.95-1.5.95-2.55v-5.1c0-2.13-1.37-3.5-3.5-3.5h-8.5c-2.13 0-3.5 1.37-3.5 3.5v2h6.44c2.44 0 4.15 1.71 4.15 4.15v4.07c-.01.23-.02.45-.05.66l.65.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41 22.59c-.47-.25-.76-.73-.76-1.27v-.76c-.88-.14-1.66-.51-2.24-1.09-.76-.76-1.16-1.8-1.16-3V12.4c0-2.26 1.48-3.92 3.68-4.13.16-.01.31-.02.47-.02h6.79c2.44 0 4.15 1.71 4.15 4.15v4.07c0 .44-.05.85-.16 1.22-.45 1.8-1.98 2.93-3.99 2.93H9.7L6.87 22.5a1.427 1.427 0 0 1-1.46.09zM5.06 9.77c-1.44.13-2.31 1.12-2.31 2.63v4.07c0 .8.25 1.47.72 1.94.46.46 1.13.71 1.93.71.41 0 .75.34.75.75v1.31l2.9-1.93c.12-.08.27-.13.42-.13h2.72c1.32 0 2.25-.66 2.54-1.82.07-.25.11-.53.11-.83V12.4c0-1.63-1.02-2.65-2.65-2.65H5.4c-.12 0-.23.01-.34.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessages3);
export default __webpack_public_path__ + "static/media/vuesax-outline-messages-3.b5a8626d45bd98d7a3e02cc36f912c15.svg";
export { ForwardRef as ReactComponent };